export function createStudentDraft() {
  return {
    id: null,
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: '',
    relationship: ''
  };
}

export function generateStudentId() {
  const now = Date.now().toString(36).toUpperCase();
  const rand = Math.random().toString(36).slice(2, 8).toUpperCase();
  return `STU-${now}-${rand}`;
}

export function validateStudent(student) {
  const errors = {};

  if (!student.firstName?.trim()) errors.firstName = 'First name is required';
  if (!student.lastName?.trim()) errors.lastName = 'Last name is required';
  if (!student.dateOfBirth?.trim()) errors.dateOfBirth = 'Date of birth is required';
  if (!student.gender?.trim()) errors.gender = 'Gender is required';
  if (!student.relationship?.trim()) errors.relationship = 'Relationship is required';

  return errors;
}
